<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="app-main-content change-charge-verify">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;">
        <el-tab-pane :label="$t('CargoMsg.Cargo_All')" name="tabAll" :lazy="true">
          <tab-change-charge-bpm :application-status="0" />
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_Processing')" name="tabDo" :lazy="true">
          <tab-change-charge-bpm :application-status="1" />
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_Approval')" name="done" :lazy="true">
          <tab-change-charge-bpm :application-status="2" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import TabChangeChargeBpm from '@/views/cargo/v0/Clearing/components/ChangeChargeVerify/tabChangeChargeBpm'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'ChangeChargeVerifyBpm',
  components: { TabChangeChargeBpm },
  data() {
    return {
      activeTabName: 'tabDo'
    }
  },
  computed: {
  },
  async created() {
    await this.init()
  },
  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
    }
  }
}
</script>

<style lang="scss">
</style>
